import { render, staticRenderFns } from "./BuyerChartUnit.vue?vue&type=template&id=4ccf9594&"
import script from "./BuyerChartUnit.vue?vue&type=script&lang=js&"
export * from "./BuyerChartUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports